import HeroSection from "./components/HeroSection";
import CategorySection from "./components/CategorySection";
import FeaturedSection from "./components/FeaturedSection";
import LatestSection from "./components/LatestSection";
import TestimonialSection from "./components/TestimonialSection";
import FaqSection from "./components/FaqSection";
import CtaBand from "./components/CtaBand";
import usePageSeo from "@/hooks/usePageSeo";
import { faqs } from "@/mocks/gua";

export default function Home() {
  usePageSeo({
    title: "蝌蚪吃瓜官网 | 合集、补档、考古旧瓜精选集",
    description:
      "蝌蚪吃瓜专注整理娱乐行业公开话题，提供合集、补档与考古旧瓜精选集，历史名场面完整收录，随时回看补课，老瓜新吃一次看个够。",
    keywords: "蝌蚪吃瓜,蝌蚪吃瓜合集,蝌蚪吃瓜补档,蝌蚪吃瓜考古,蝌蚪吃瓜精选集",
    canonical: "/",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "蝌蚪吃瓜",
        url: "https://cndonglong.cn",
        inLanguage: "zh-CN",
        potentialAction: {
          "@type": "SearchAction",
          target: "https://cndonglong.cn/heji?q={search_term_string}",
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "蝌蚪吃瓜",
        url: "https://cndonglong.cn",
        description:
          "专注整理娱乐行业公开话题的内容聚合站，以合集、补档、考古旧瓜为主要内容形态。",
        email: "hello@tadpolegua.com",
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.map((f) => ({
          "@type": "Question",
          name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a },
        })),
      },
    ],
  });

  return (
    <>
      <HeroSection />
      <CategorySection />
      <FeaturedSection />
      <LatestSection />
      <TestimonialSection />
      <FaqSection />
      <CtaBand />
    </>
  );
}